<div class="partnerUsersDiv" *transloco="let translate">
    <div class="align-items-center d-flex justify-content-between">
        <span class="selectLocSpan" [textContent]="translate('Assign Users') + ':'"></span>
        <mat-form-field class="col-3">
            <mat-label *transloco="let translate">{{ translate('Search User') }}</mat-label>
            <input matInput type="text" name="searchUser" [(ngModel)]="searchUser" (ngModelChange)="searchUserChange.emit($event)" (keyup)="searchAssignUsers.emit()" />
            <material-button matSuffix [classList]="['selectCloseIcon']" *ngIf="searchUser" buttonType="icon" size="small" [titleText]="'Clear'" prefixIconType="material" prefixIcon="close" (buttonClicked)="$event.stopPropagation(); clearSearchUsers.emit()"></material-button>
        </mat-form-field>
    </div>
    <div class="selectAllDiv" *ngIf="!noAssignUsers">
        <material-checkbox class="mr-1" [(model)]="allUsersSelected" [name]="'Select All'" (modelChange)="selectAllUsers.emit($event)" id="selectAllPartnerUsers" [showName]="true"></material-checkbox>
    </div>
    <div class="partnerUsersMainDiv">
        <ng-container *ngIf="!noAssignUsers; else radioType">
            <div class="form-check assignUsersList">
                <ng-container *ngIf="users | FilterPipe : 'fullName' : searchUser | orderBy : 'fullName' as result">
                    <ng-container *ngIf="result.length; else noSearchUsers">
                        <span *ngFor="let user of result">
                            <material-checkbox class="mr-1 selectbox" [(model)]="user.selected" [name]="user.fullName" [id]="user.id" (modelChange)="checkUsersList.emit({user, $event})" [showName]="true"></material-checkbox>
                        </span>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
        <ng-template #radioType>
            <ng-container *ngIf="computedRadioOptions.length; else noSearchUsers">
                <material-radio-group [radioOptions]="computedRadioOptions" [selectedValue]="selectedUser" [ariaLabelledBy]="'users'" [disabled]="radioDisabled" [radioGroupClassList]="['!grid', '!grid-cols-3']" [radioButtonClassList]="['adjust-target']" (selectionChanged)="checkUsersList.emit({ selectedUser: $event, $event })"></material-radio-group>
            </ng-container>
        </ng-template>
        <mat-error *ngIf="errors?.user?.length" [textContent]="errors?.user?.[0]">
        </mat-error>
    </div>
</div>

<ng-template *ngIf="!users.length">
    <div class="noUsersSelectedDiv" *transloco="let translate">
        <div class="noUserMsg">
            <span [textContent]="translate('There are no users')"></span>
        </div>
    </div>
</ng-template>
<ng-template #noSearchUsers>
    <div class="d-flex justify-content-center noUsersFound" *transloco="let translate">
        <span [textContent]="translate('No users found')"></span>
    </div>
</ng-template>
